import Timestamp from "components/Timestamp";

import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestOpenedAtCell = ({
  item: pullRequest,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <Timestamp timestamp={pullRequest.createdAt} />
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestOpenedAtCell;
